import { acctServerInstance } from "../axios/instances";
import {
    LOCAL_ORDER_COUNT,
    LOCAL_ORDER_COUNT_SUCCESS,
    LOCAL_ORDER_COUNT_FAIL
} from './types';

export function localOrderCount(startTime, endTime) {   
    return function(dispatch) {
        dispatch({type: LOCAL_ORDER_COUNT})
        return acctServerInstance.get(`/prod/uni2/public/query/locaordercount?time1=${startTime}&time2=${endTime}`).then(({data}) => {
            dispatch({
                type: LOCAL_ORDER_COUNT_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: LOCAL_ORDER_COUNT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}
